module.exports = __webpack_public_path__ + "img/lottery-2D.570f8e80.png";